module.exports = __webpack_public_path__ + "assets/img/3-3.b10b6898.png";